import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { ResizeObserver } from 'resize-observer';
import { ResponsiveContext } from "./ResponsiveContext";
import { calculatePlayerSize, getInitialContextState } from "./utils";
import { jsx as _jsx } from "react/jsx-runtime";
var ResponsiveProvider = function ResponsiveProvider(_ref) {
  var playerRef = _ref.playerRef,
    defaultPlayerSize = _ref.defaultPlayerSize,
    defaultPlayerHeight = _ref.defaultPlayerHeight,
    disablePlayerSizeCalculation = _ref.disablePlayerSizeCalculation,
    children = _ref.children;
  var _useState = useState(getInitialContextState({
      defaultPlayerSize: defaultPlayerSize,
      defaultPlayerHeight: defaultPlayerHeight
    })),
    _useState2 = _slicedToArray(_useState, 2),
    _useState2$ = _useState2[0],
    playerSize = _useState2$.playerSize,
    playerHeight = _useState2$.playerHeight,
    setResponsiveState = _useState2[1];
  useEffect(function () {
    var resizeObserver;
    if (playerRef.current && !disablePlayerSizeCalculation) {
      setResponsiveState(calculatePlayerSize({
        width: playerRef.current.clientWidth,
        height: playerRef.current.clientHeight,
        defaultPlayerSize: defaultPlayerSize,
        defaultPlayerHeight: defaultPlayerHeight
      }));
      resizeObserver = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          setResponsiveState(calculatePlayerSize({
            width: entry.target.clientWidth,
            height: entry.target.clientHeight,
            defaultPlayerSize: defaultPlayerSize,
            defaultPlayerHeight: defaultPlayerHeight
          }));
        });
      });
      resizeObserver.observe(playerRef.current);
    }
    return function () {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [playerRef, disablePlayerSizeCalculation, defaultPlayerSize, defaultPlayerHeight]);
  var recalculatePlayerSize = useCallback(function () {
    if (playerRef.current) {
      setResponsiveState(calculatePlayerSize({
        width: playerRef.current.clientWidth,
        height: playerRef.current.clientHeight,
        defaultPlayerSize: defaultPlayerSize,
        defaultPlayerHeight: defaultPlayerHeight
      }));
    }
  }, [playerRef, defaultPlayerSize, defaultPlayerHeight]);
  var contextValue = useMemo(function () {
    return {
      recalculatePlayerSize: recalculatePlayerSize,
      playerSize: playerSize,
      playerHeight: playerHeight
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [recalculatePlayerSize,
  // Destructured object dependency to avoid unnecessary rerenders
  playerSize.value, playerSize.valueByHeight, playerSize.matches.xxs, playerSize.matches.xs, playerSize.matches.sm, playerSize.matches.md, playerSize.matches.lg, playerHeight]);
  return /*#__PURE__*/_jsx(ResponsiveContext.Provider, {
    value: contextValue,
    children: children
  });
};
export default ResponsiveProvider;